import { format } from 'date-fns';

export function getFilenameTimestamp(date: Date = new Date()): string {
  return format(date, 'yyyy-MM-dd_HH-mm-ss');
}
